import {addColor} from './TriangleButton';
import theme from 'theme';

const YellowTriangleButton = (props) => {
  return addColor(theme.design.default.light, theme.design.default.dark)(props);
};

export default YellowTriangleButton;